import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { protocolLogAction } from "actions/changeActiveItemActions";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

let FIRST_DN_NETWORK_DEVICE = 0;
let LAST_DN_NETWORK_DEVICES = 70;
const LINE_MAP_PLACEHOLDER = <React.Fragment><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell><Table.Cell></Table.Cell></React.Fragment>;

const START_MULTIPLIER = 10;
const END_INCREMENT = 10;

const UtilsInstance = new Utils();

class LiveList extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);

    this.state = {
      sortDirection: "ascending",
      devices: [],
      devicesMatrixList: [],
      firstLineMap: LINE_MAP_PLACEHOLDER,
      secondLineMap: LINE_MAP_PLACEHOLDER,
      thirdLineMap: LINE_MAP_PLACEHOLDER,
      fourthLineMap: LINE_MAP_PLACEHOLDER,
      fifthLineMap: LINE_MAP_PLACEHOLDER,
      sixthLineMap: LINE_MAP_PLACEHOLDER,
      seventhLineMap: LINE_MAP_PLACEHOLDER,
      controller: new AbortController()
    };
  }

  retrieveData = ()  => {

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "liveList/protocol", { mode: "cors", signal: this.state.controller.signal })
      .then(res => res.json())
      .then(data => this.setState({ devices: data }, () => {
        this.setState({ devicesMatrixList: [] }, () => {
          const matrixList = this.createLiveListMatrixList(this.state.devices);
          this.buildLineMaps(matrixList);
        });
      }))
      .catch((e) => {
        console.log("Request interrupted: ", e);
      });
  }

  createLiveListMatrixList = (devices) => {
    let totalNumOfDevices = devices.length;
    let numOfInsertedDevices = 0;

    let devicesMatrixList = [];

    for (let i = FIRST_DN_NETWORK_DEVICE; i < LAST_DN_NETWORK_DEVICES; i++) {
      let hasPositionBeenFilled = false;

      // Only look for devices to insert if not all of them have been already inserted
      if (numOfInsertedDevices < totalNumOfDevices) {
        for (let j = 0; j < devices.length; j++) {
          if (devices[j].address === i || devices[j].addressMestre === i) {
            devicesMatrixList.push(devices[j]);
            hasPositionBeenFilled = true;
            numOfInsertedDevices++;
            break;
          }
        }
      }

      if (!hasPositionBeenFilled) {
        devicesMatrixList.push({
          "aOk": true,
          "address": i,
          "amplitude": 0,
          "amplitudeMinima": 0,
          "bOk": true,
          "overshooting": 0,
          "status": ""
        });
      }

    }

    return devicesMatrixList;
  }

  buildLineMaps = (devicesMatrixList) => {
    let firstLineStart = START_MULTIPLIER * (1 - 1);
    let firstLineEnd = firstLineStart + END_INCREMENT;

    let secondLineStart = START_MULTIPLIER * (2 - 1);
    let secondLineEnd = secondLineStart + END_INCREMENT;

    let thirdLineStart = START_MULTIPLIER * (3 - 1);
    let thirdLineEnd = thirdLineStart + END_INCREMENT;

    let fourthLineStart = START_MULTIPLIER * (4 - 1);
    let fourthLineEnd = fourthLineStart + END_INCREMENT;

    let fifthLineStart = START_MULTIPLIER * (5 - 1);
    let fifthLineEnd = fifthLineStart + END_INCREMENT;

    let sixthLineStart = START_MULTIPLIER * (6 - 1);
    let sixthLineEnd = sixthLineStart + END_INCREMENT;

    let seventhLineStart = START_MULTIPLIER * (7 - 1);
    let seventhLinEnd = seventhLineStart + END_INCREMENT;

    let firstLine = devicesMatrixList.slice(firstLineStart, firstLineEnd);
    let secondLine = devicesMatrixList.slice(secondLineStart, secondLineEnd);
    let thirdLine = devicesMatrixList.slice(thirdLineStart, thirdLineEnd);
    let fourthLine = devicesMatrixList.slice(fourthLineStart, fourthLineEnd);
    let fifthLine = devicesMatrixList.slice(fifthLineStart, fifthLineEnd);
    let sixthLine = devicesMatrixList.slice(sixthLineStart, sixthLineEnd);
    let seventhLine = devicesMatrixList.slice(seventhLineStart, seventhLinEnd);

    this.setState({
      firstLineMap: firstLine.map(device => (this.createDeviceCell(device))),
      secondLineMap: secondLine.map(device => (this.createDeviceCell(device))),
      thirdLineMap: thirdLine.map(device => (this.createDeviceCell(device))),
      fourthLineMap: fourthLine.map(device => (this.createDeviceCell(device))),
      fifthLineMap: fifthLine.map(device => (this.createDeviceCell(device))),
      sixthLineMap: sixthLine.map(device => (this.createDeviceCell(device))),
      seventhLineMap: seventhLine.map(device => (this.createDeviceCell(device))),
    });
  }

  handleCellClick = (address) => () => {
    this.props.onChangeLog();
    this.props.history.push({
      pathname: "/protocol-log",
      state: { deviceAddress: address }
    });
  }

  createDeviceCell = (device) => {
    if (device.status === Constants.GOOD) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={goodCellStyle}
          onClick={this.handleCellClick(device.address, device.status)}>
          {Strings.GOOD_STRING_PROTOCOL}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.FAULT) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={badCellStyle}
          onClick={this.handleCellClick(device.address, device.status)}>
          {Strings.FAULT_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.DIAGNOSTIC) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={diagnosticCellStyle}
          onClick={this.handleCellClick(device.address, device.status)}>
          {Strings.DIAGNOSTIC_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.MASTER) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={masterCellStyle}>
          {Strings.MASTER_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.MISSING) {
      return (
        <Table.Cell selectable
          key={device.address}
          style={missingCellStyle}>
          {Strings.MISSING_SINGULAR_STRING}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          disabled
          key={device.address}
          style={hiddenTableCellStyle}>
          {Strings.UNKNOWN_STRING}
        </Table.Cell>
      );
    }
  }

  getTableBasedOnWindowHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();

    let browserHeightStyle = {
      height: browserHeight * 0.85
    };

    let tableSize = "large";

    if (browserHeight > 800) {
      browserHeightStyle = {
        height: browserHeight * 0.85
      };
      tableSize = "large";
    }
    else if (browserHeight > 655 && browserHeight <= 800) {
      browserHeightStyle = {
        height: browserHeight * 0.85
      };
      tableSize = "small";
    }
    else {
      browserHeightStyle = {
        height: browserHeight * 0.7
      };
      tableSize = "small";
    }

    return (
      <Table id="main-table" celled fixed singleLine textAlign="center" size={tableSize} definition style={browserHeightStyle}>
        <Table.Header fullWidth>
          <Table.Row>
            <Table.HeaderCell width="1" />
            <Table.HeaderCell>0</Table.HeaderCell>
            <Table.HeaderCell>1</Table.HeaderCell>
            <Table.HeaderCell>2</Table.HeaderCell>
            <Table.HeaderCell>3</Table.HeaderCell>
            <Table.HeaderCell>4</Table.HeaderCell>
            <Table.HeaderCell>5</Table.HeaderCell>
            <Table.HeaderCell>6</Table.HeaderCell>
            <Table.HeaderCell>7</Table.HeaderCell>
            <Table.HeaderCell>8</Table.HeaderCell>
            <Table.HeaderCell>9</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row> <Table.Cell verticalAlign="middle">0</Table.Cell> {this.state.firstLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">10</Table.Cell> {this.state.secondLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">20</Table.Cell> {this.state.thirdLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">30</Table.Cell> {this.state.fourthLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">40</Table.Cell> {this.state.fifthLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">50</Table.Cell> {this.state.sixthLineMap} </Table.Row>
          <Table.Row> <Table.Cell verticalAlign="middle">60</Table.Cell> {this.state.seventhLineMap} </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    let intervalID = setInterval(this.retrieveData, 5000);
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.intervalID);
  }

  // Render the table containing all network devices
  render() {
    return (
      <div style={screenStyle}>
        <div id="main-table-container">
          {this.getTableBasedOnWindowHeight()}
        </div>
      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "0vh 1vw",
  textAlign: "center"
};

const goodCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const diagnosticCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle"
};

const masterCellStyle = {
  color: "black",
  backgroundColor: "white",
  verticalAlign: "middle"
};

const badCellStyle = {
  color: "black",
  backgroundColor: "#FF5722",
  verticalAlign: "middle"
};

const mapActionsToProps = {
  onChangeLog: protocolLogAction
};

const hiddenTableCellStyle = {
  color: "white"
};

const missingCellStyle = {
  color: "white",
  backgroundColor: "#708090",
  verticalAlign: "middle"
};

export default connect(null, mapActionsToProps)(withRouter(LiveList));

